import { render, staticRenderFns } from "./TheSent.vue?vue&type=template&id=8f8d9470&"
import script from "./TheSent.vue?vue&type=script&lang=js&"
export * from "./TheSent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports